import type { RouteRecordRaw } from "vue-router";

export const FlowListRoutes: RouteRecordRaw[] = [
  {
    path: "flows",
    name: "flows",
    component: () => import("@/domain/Flows/FlowList/presentation/pages/FlowsListPage.vue"),
    meta: { requiresAuth: true, permissions: "flows.read" },
  },
  {
    path: "flow/:id/sessions",
    name: "flowSessions",
    component: () => import("@/domain/Flows/FlowList/presentation/pages/FlowSessionsPage.vue"),
    meta: { requiresAuth: true, permissions: "flows.read" },
  },
  {
    path: "flow/:id/sessions/:sessionId/detail",
    name: "flowSessionDetail",
    component: () => import("@/domain/Flows/FlowList/presentation/pages/FlowSessionDetailPage.vue"),
    meta: { requiresAuth: true, permissions: "flows.read" },
  },
  {
    path: "flow/:id/sessions/:sessionId/detail/webservices-attempts",
    name: "flowSessionWebserviceAttempts",
    component: () => import("@/domain/Flows/FlowList/presentation/pages/FlowWebserviceAttemptsPage.vue"),
    meta: { requiresAuth: true, permissions: "flows.read" },
  },
  {
    path: "flow-builder",
    name: "flowBuilder",
    component: () => import("@/domain/Flows/FlowList/presentation/pages/FlowBuilderPage.vue"),
    meta: { requiresAuth: true },
  },
];
